<template>
<div>
  <v-row>
    {{inscricao}}
    <v-col>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="8">
            <search-box
                :emit-all-properties="true"
                label="* Evento"
                popup-label="Selecione uma Evento Ativa"
                :id.sync="inscricao.idEventoEdicao"
                :descricao.sync="inscricao.descricao"
                :value="edicao"
                :loader-fn="loaderEdicoesAtivas"
                item-key="id"
                item-text="descricao"
                :rules="[
                      this.$validators.string.required,
                      this.$validators.notNullOrUndefined
                  ]">
              <template v-slot:empty>
                <p class="ma-2">
                  Nenhum Evento ativo encontrado
                </p>
              </template>
            </search-box>
          </v-col>
          <v-col cols="12" md="4">
            <v-btn color="primary" @click="salvar" :disabled="loading || !valid">Efetivar Inscrição</v-btn>
          </v-col>
        </v-row>                          
      </v-form>
    </v-col>
  </v-row>
</div>
</template>

<script>
import SearchBox from "../../../components/shared/common/SearchBox";
import {findAllEventoEdicaoAtivas} from "../../../api/eventoEdicao";

export default {
  name: "InscrevaSeForm",
  components: {SearchBox},
  props: {
    inscricao: {
      type: Object
    },
    idEvento: {
      type: Number
    },
    loading: {
      type: Boolean
    }
  },
  data () {
    return {
      valid: false,
    }
  },
  watch: {
    'inscricao.idEventoEdicao': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue){
          this.$emit('sendIdEventoEdicaoToInscrevase',this.inscricao.idEventoEdicao);
        }
      }
    },
  },  
  methods: {
    loaderEdicoesAtivas(page, search) {
      return findAllEventoEdicaoAtivas(page, this.idEvento, {
        descricao: search
      })
    },
    salvar(){
      if(!this.$refs.form.validate()) return;
      this.$emit('onSave',this.inscricao.idEvento);
    }
  },
  computed: {
    edicao() {
      if(this.inscricao.idEventoEdicao == null) {
        this.inscricao.descricao = null;
        return null
      };
      return {
        id: this.inscricao.idEventoEdicao,
        descricao: this.inscricao.descricao,
      }
    },
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>